<template>
  <svg id="icon-lock" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-36.5-12.5h554v512h-554z"/>
      <g transform="translate(4.5 4)" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
        <rect fill="currentColor" x=".458" y="5.5" width="10.083" height="6.417" rx="2"/>
        <path d="M2.75 4.583V2.546C2.75 1.14 3.981 0 5.5 0s2.75 1.14 2.75 2.546v2.037" fill="none"/>
      </g>
    </g>
  </svg>
</template>
